<template>
  <el-row>
    <el-form :model="carExhibitionVideoDetailForm"
             ref="carExhibitionVideoDetailRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="/carShow/carShowInfo/saveAdvertisement.action"
             editAction="/carShow/carShowInfo/editAdvertisement.action"
             selectAction="/carShow/carShowInfo/selectAdvertisement.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="视频标题" prop="publicWeChatUrl">
        <el-input v-model="carExhibitionVideoDetailForm.title"  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="视频链接" prop="publicWeChatUrl">
        <el-input v-model="carExhibitionVideoDetailForm.link"  placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="上传封面" prop="image">
        <el-upload v-model="carExhibitionVideoDetailForm.image" :data="{floder:'csAdvertisement'}"  :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <img :src="carExhibitionVideoDetailForm.image.url"
               class="avatar" v-if="carExhibitionVideoDetailForm.image">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip"><p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'carExhibitionVideoDetail',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {},
      carExhibitionVideoDetailForm: {
        id: null,
        type: 2,
        image: null
      }
    }
  },
  created () {
    this.carExhibitionVideoDetailForm.id = this.$route.query.id
    this.carExhibitionVideoDetailForm.carShowInfoId = this.$route.query.carShowInfoId
  },
  methods: {
    onFilterParams: function (params) {},
    onSelectInfo: function (dataInfo) {}
  },
  filters: {}

}
</script>

<style scoped>

</style>
